import { Skeleton } from '@pharmaconnect/ui/web'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAuthStore } from '../stores/authStore'

import { MfaChallenge } from './MfaChallenge'

/**
 * Garde-fou de routes :
 *   1. Skeleton pendant le chargement initial
 *   2. Redirect vers /login si pas de session
 *   3. MFA challenge si AAL2 requis (TOTP enrollé) mais session en AAL1
 *   4. Sinon, render <Outlet />
 */
export function AuthGuard() {
  const location = useLocation()
  const loading = useAuthStore((s) => s.loading)
  const session = useAuthStore((s) => s.session)
  const profile = useAuthStore((s) => s.profile)
  const mfaRequired = useAuthStore((s) => s.mfaRequired)

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-pharmacist-bg">
        <div className="w-64 space-y-3">
          <Skeleton height="h-6" width="w-1/2" />
          <Skeleton height="h-4" />
          <Skeleton height="h-4" width="w-3/4" />
        </div>
      </div>
    )
  }

  if (!session || !profile) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />
  }

  if (mfaRequired) {
    return <MfaChallenge />
  }

  return <Outlet />
}
